<template>
  <b-card title="تولید محتوا با هوش مصنوعی">
    <p class="text-muted mb-2">
      متن‌ها با هوش مصنوعی تولید می‌شوند؛ پیش از استفاده یک بازبینی کوتاه انجام دهید.
    </p>

    
    <b-tabs pills>
      <!-- توضیح محصول -->
      <b-tab
        title="توضیح محصول"
        active
      >
        <b-row class="mt-1">
          <b-col md="6">
            <b-form-group label="نام محصول">
              <b-form-input
                v-model="pd.ProductName"
                placeholder="مثلاً: کفش ورزشی مردانه نایک مدل ایر"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="ویژگی‌ها (اختیاری)">
              <b-form-input
                v-model="pd.Attributes"
                placeholder="جنس، رنگ، کاربرد، سایز…"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          :disabled="pd.loading || !pd.ProductName"
          @click="run('productDescription', pd, { ProductName: pd.ProductName, Attributes: pd.Attributes })"
        >
          <b-spinner
            v-if="pd.loading"
            small
          />
          تولید توضیح
        </b-button>

        <div
          v-if="pd.result"
          class="mt-1"
        >
          <b-form-textarea
            :value="pd.result"
            rows="5"
            readonly
          />
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mt-1"
            @click="copy(pd.result)"
          >کپی</b-button>
        </div>
      </b-tab>

      <!-- سئو -->
      <b-tab title="عنوان و متای سئو">
        <b-row class="mt-1">
          <b-col md="8">
            <b-form-group label="موضوع / عنوان صفحه">
              <b-form-input
                v-model="seo.Subject"
                placeholder="مثلاً: خرید عطر مردانه"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="نوع صفحه">
              <b-form-select
                v-model="seo.PageType"
                :options="pageTypes"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          :disabled="seo.loading || !seo.Subject"
          @click="runSeo()"
        >
          <b-spinner
            v-if="seo.loading"
            small
          />
          تولید سئو
        </b-button>

        <div
          v-if="seo.result"
          class="mt-1"
        >
          <b-form-textarea
            :value="seo.result"
            rows="4"
            readonly
          />
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mt-1"
            @click="copy(seo.result)"
          >کپی</b-button>
        </div>
      </b-tab>

      <!-- متن دسته -->
      <b-tab title="متن دسته‌بندی">
        <b-row class="mt-1">
          <b-col md="6">
            <b-form-group label="نام دسته">
              <b-form-input
                v-model="cat.CategoryName"
                placeholder="مثلاً: لوازم آشپزخانه"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          :disabled="cat.loading || !cat.CategoryName"
          @click="run('categoryText', cat, { CategoryName: cat.CategoryName })"
        >
          <b-spinner
            v-if="cat.loading"
            small
          />
          تولید متن دسته
        </b-button>

        <div
          v-if="cat.result"
          class="mt-1"
        >
          <b-form-textarea
            :value="cat.result"
            rows="5"
            readonly
          />
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mt-1"
            @click="copy(cat.result)"
          >کپی</b-button>
        </div>
      </b-tab>

      <!-- مقاله -->
      <b-tab title="مقاله وبلاگ">
        <b-row class="mt-1">
          <b-col md="8">
            <b-form-group label="موضوع مقاله">
              <b-form-input
                v-model="art.Topic"
                placeholder="مثلاً: راهنمای انتخاب لپ‌تاپ برای دانشجو"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="کلمات کلیدی (اختیاری)">
              <b-form-input
                v-model="art.Keywords"
                placeholder="با ویرگول جدا کنید"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-checkbox
          v-model="art.WithImage"
          class="mb-1"
        >
          تولید تصویر کاور همراه مقاله
        </b-form-checkbox>
        <b-button
          variant="primary"
          :disabled="art.loading || !art.Topic"
          @click="runArticle()"
        >
          <b-spinner
            v-if="art.loading"
            small
          />
          تولید مقاله
        </b-button>

        <div
          v-if="art.cover"
          class="mt-1"
        >
          <img
            :src="fullUrl(art.cover)"
            alt="کاور"
            style="max-width:320px;border-radius:12px"
          >
        </div>
        <div
          v-if="art.title"
          class="mt-1"
        >
          <b-form-group label="عنوان">
            <b-form-input
              :value="art.title"
              readonly
            />
          </b-form-group>
        </div>
        <div
          v-if="art.result"
          class="mt-1"
        >
          <label class="d-block mb-25">بدنه‌ی HTML مقاله</label>
          <b-form-textarea
            :value="art.result"
            rows="12"
            readonly
          />
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mt-1"
            @click="copy(art.result)"
          >کپی</b-button>
        </div>
        <div
          v-if="art.result"
          class="border rounded p-1 mt-1"
        >
          <small class="text-muted d-block mb-1">پیش‌نمایش:</small>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="art.result" />
        </div>
      </b-tab>

      <!-- بهبود عکس محصول -->
      <b-tab title="بهبود عکس محصول">
        <b-row class="mt-1">
          <b-col md="6">
            <b-form-group label="عکس محصول">
              <b-form-file
                v-model="img.file"
                accept="image/*"
                placeholder="یک عکس انتخاب کنید…"
                browse-text="انتخاب"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="دستور دلخواه (اختیاری)">
              <b-form-input
                v-model="img.instruction"
                placeholder="مثلاً: پس‌زمینه سفید، حذف شلوغی اطراف"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          :disabled="img.loading || !img.file"
          @click="runImage()"
        >
          <b-spinner
            v-if="img.loading"
            small
          />
          بهبود عکس
        </b-button>

        <div
          v-if="img.result"
          class="mt-1"
        >
          <img
            :src="fullUrl(img.result)"
            alt="عکس بهبودیافته"
            style="max-width:320px;border-radius:12px;border:1px solid #eee"
          >
          <div class="mt-1">
            <b-button
              size="sm"
              variant="outline-secondary"
              :href="fullUrl(img.result)"
              target="_blank"
            >دانلود / مشاهده</b-button>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
export default {
  name: 'AiTools',
  data() {
    return {
      pageTypes: [
        { value: 'product', text: 'محصول' },
        { value: 'category', text: 'دسته‌بندی' },
        { value: 'blog', text: 'مقاله' },
        { value: 'page', text: 'صفحه' },
      ],
      pd: {
        ProductName: '', Attributes: '', result: '', loading: false,
      },
      seo: {
        Subject: '', PageType: 'product', result: '', loading: false,
      },
      cat: { CategoryName: '', result: '', loading: false },
      art: {
        Topic: '', Keywords: '', WithImage: true, title: '', result: '', cover: '', loading: false,
      },
      img: {
        file: null, instruction: '', result: '', loading: false,
      },
    }
  },
  methods: {
    run(endpoint, state, payload, onResult) {
      state.loading = true
      this.$http.post(this.$api.ai[endpoint], payload)
        .then(res => {
          const data = res.data || {}
          if (onResult) onResult(data)
          else state.result = data.text || ''
        })
        .catch(() => {
          this.toastError()
        })
        .finally(() => {
          state.loading = false
        })
    },
    runSeo() {
      this.run('seo', this.seo, { Subject: this.seo.Subject, PageType: this.seo.PageType }, data => {
        this.seo.result = `عنوان: ${data.title || ''}\n\nمتا: ${data.description || ''}`
      })
    },
    runArticle() {
      this.run('article', this.art, { Topic: this.art.Topic, Keywords: this.art.Keywords, WithImage: this.art.WithImage }, data => {
        this.art.title = data.title || ''
        this.art.result = data.html || data.text || ''
        this.art.cover = data.coverImage || ''
      })
    },
    runImage() {
      if (!this.img.file) return
      this.img.loading = true
      this.img.result = ''
      const fd = new FormData()
      fd.append('file', this.img.file)
      fd.append('instruction', this.img.instruction || '')
      this.$http.post(this.$api.ai.productImage, fd)
        .then(res => {
          this.img.result = (res.data && res.data.path) ? res.data.path : ''
        })
        .catch(() => {
          this.toastError()
        })
        .finally(() => {
          this.img.loading = false
        })
    },
    fullUrl(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path
      const base = (this.$http && this.$http.defaults && this.$http.defaults.baseURL) || process.env.VUE_APP_BASE_URL || ''
      const origin = base.replace(/\/api\/?$/, '')
      return origin + path
    },
    copy(text) {
      if (!text) return
      navigator.clipboard.writeText(text)
      if (this.$bvToast) {
        this.$bvToast.toast('در کلیپ‌بورد کپی شد.', { title: 'انجام شد', variant: 'success', solid: true })
      }
    },
    toastError() {
      if (this.$bvToast) {
        this.$bvToast.toast('خطا در تولید محتوا. دوباره تلاش کنید.', { title: 'خطا', variant: 'danger', solid: true })
      }
    },
  },
}
</script>
